<template>
  <div>
    <a-form-model
      ref="emailForm"
      :model="company"
      :rules="rules"
      layout="vertical"
    >
      <a-row :gutter="16">
        <a-col :span="18">
          <a-form-model-item
            label="Email address to sign up for GLS"
            prop="email"
          >
            <a-input
              :disabled="isInvited"
              ref="email"
              placeholder="Email"
              v-model="company.email"
              autofocus
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>
<script>
import { helper } from "../../../Utilities/helper";

export default {
  mounted() {
    this.$refs.email.focus();
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    invitation: Object,
    events: { type: Object, required: true },
    validate: Boolean,
  },
  data() {
    return {
      rules: {
        email: [
          { required: true, message: "Please input an email", trigger: "blur" },
          { validator: helper.emailValidator, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    validate(newVal) {
      if (newVal) {
        this.$emit(this.events.validationStarted);
        this.$refs.emailForm.validate((valid) => {
          this.$emit(this.events.validationEnded);
          if (valid) {
            this.$emit(this.events.moveNext, {
              source: "BasicDetails",
              isValid: true,
            });
          }
        });
      }
    },
  },
  computed: {
    isInvited() {
      return !!this.invitation?.emailAddress;
    }
  }
};
</script>
<style scoped>
.ant-input-disabled {
  color: rgba(0, 0, 0, 0.65) !important;
}
</style>